import React from 'react';
import { Link } from 'react-router-dom';
import MainCountdown from './MainCountdown';

const MainMinting = ({ openModal, textData, loacalelang }) => {
	return (
		<>
			<p className='kct_minting_header'>1ST KONNECT NFT MINTING</p>
			<MainCountdown />
			<div className='kct_duman_pfpBox'>
				<p className='pfpBox_header'>DUMAN PFP MINTING</p>
				<hr />
				{window.innerWidth < 1024 ? (
					<p className='pfpBox_info' style={{ whiteSpace: 'pre' }}>
						{textData && textData.main.pfpInfo}
					</p>
				) : (
					<p className='pfpBox_info' style={{ whiteSpace: 'pre' }}>
						{textData && textData.main.e_pfpInfo}
					</p>
				)}
				<hr />
				<p className='pfpBox_minting_info'>
					Minting Time : TBA
					<br />
					{textData && textData.main.pfpQuantity}
					<br />
					{textData && textData.main.pfpPrice}
					<br />
					{textData && textData.main.pfpDiscount}
					<br />
				</p>
				<div className='kct_pfp_rarity_table'>
					<h5>DUMAN PFP rarity</h5>
					<table>
						<thead>
							<tr>
								<th>
									{loacalelang !== 'ko' ? 'Breed' : '품종'}
								</th>
								<th>
									{loacalelang !== 'ko' ? 'Poodle' : '푸들'}
								</th>
								<th>
									{loacalelang !== 'ko'
										? 'Border collie'
										: '보더콜리'}
								</th>
								<th>
									{loacalelang !== 'ko'
										? 'Doberman'
										: '도베르만'}
								</th>
								<th>
									{loacalelang !== 'ko'
										? 'Shiba Inu'
										: '시바'}
								</th>
								<th>
									{loacalelang !== 'ko'
										? 'French bulldog'
										: '프렌치 불독'}
								</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>
									{loacalelang !== 'ko' ? 'Quantity' : '수량'}
								</td>
								<td>50</td>
								<td>100</td>
								<td>200</td>
								<td>400</td>
								<td>750</td>
							</tr>
							<tr>
								<td>
									{loacalelang !== 'ko' ? 'Rarity' : '희소성'}
								</td>
								<td>3%</td>
								<td>7%</td>
								<td>13%</td>
								<td>27%</td>
								<td>50%</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<div className='kct_pfp_rarity_btn'>
				<button
					disabled={true}
					style={{ opacity: 0.5 }}
					onClick={
						openModal
						// ()=>{
						//     alert(textData.header.closed);
						// }
					}
				>
					{textData.main.vitualMinting} &#62;
				</button>
				<button>
					<Link
						to='Gallery'
						style={{ textDecoration: 'none', color: '#fff' }}
					>
						{textData.main.virtualGallery} &#62;
					</Link>
				</button>
			</div>
		</>
	);
};

export default MainMinting;
